import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { Observable } from 'rxjs';

import { PortletBodyComponent } from './portlet-body.component';
import { PortletFooterComponent } from './portlet-footer.component';

export interface PortletOptions {
  test?: any;
}

@Component({
    selector: 'kt-portlet',
    templateUrl: './portlet.component.html',
    styles: [':host { display: flex; height: 100%; flex-direction: column }'],
    exportAs: 'ktPortlet',
    standalone: false
})
export class PortletComponent {
  @Input() loading$?: Observable<boolean>;
  @Input() options?: PortletOptions;
  @Input() class?: string;

  @ViewChild('portlet', { static: true }) portlet?: ElementRef;

  @ViewChild(PortletBodyComponent, { static: true }) body?: PortletBodyComponent;
  @ViewChild(PortletFooterComponent, { static: true }) footer?: PortletFooterComponent;
}
